.body{font-family:Roboto,Helvetica Neue,sans-serif;font-size:18px;font-weight:400;line-height:24px;padding:1.5rem .75rem 1.5rem 1.5rem}.row{margin-top:1rem;margin-left:0rem;margin-right:0rem}
/*# sourceMappingURL=delete-device.component-KIBHKIG3.css.map */
